///
/// EarthBrowser
///
/// Created by Matt Giger on 9/18/2026
/// Copyright (c) 2026 Geodata Labs
///
/// Server registration of Web Push subscriptions. The browser-side
/// subscribe/unsubscribe lives in utils/webPush; these endpoints persist
/// the result so the alert evaluator can deliver to every browser the
/// user enabled.
///
import type {
	ListPushSubscriptionsResponse,
	PushSubscriptionRecord,
	RegisterPushSubscriptionRequest,
} from "@shared-types"
import { authenticatedApi } from "./API/authenticatedApi"

export const pushSubscriptionsApi = authenticatedApi.injectEndpoints({
	endpoints: (builder) => ({
		listPushSubscriptions: builder.query<ListPushSubscriptionsResponse, void>({
			query: () => "/api/user/push-subscriptions",
			providesTags: ["PushSubscriptions"],
		}),
		registerPushSubscription: builder.mutation<{ subscription: PushSubscriptionRecord }, RegisterPushSubscriptionRequest>({
			query: (body) => ({
				url: "/api/user/push-subscriptions",
				method: "PUT",
				body,
			}),
			invalidatesTags: ["PushSubscriptions"],
		}),
		unregisterPushSubscription: builder.mutation<{ success: boolean }, string>({
			query: (endpoint) => ({
				url: "/api/user/push-subscriptions",
				method: "DELETE",
				body: { endpoint },
			}),
			invalidatesTags: ["PushSubscriptions"],
		}),
	}),
})

export const {
	useListPushSubscriptionsQuery,
	useRegisterPushSubscriptionMutation,
	useUnregisterPushSubscriptionMutation,
} = pushSubscriptionsApi
